import React, { useState } from 'react';
import Application from "../../classes/Application";
import { useLocation } from "react-router-dom";

export default function TestCfg() {
    const cfg = Application.getInstance().getConfig();

    const testkey="publicarea"

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [enabled, setEnabled] = useState<string | null>(() => {
        const localStorageValue = localStorage.getItem(testkey);
        if (localStorageValue === "true") {
            return "true";
        }
        return queryParams.get("enabled");
    });

    if (enabled === "true") {
        localStorage.setItem(testkey, "true");
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        const newEnabled = isChecked ? "true" : "false";
        localStorage.setItem(testkey, newEnabled);
        setEnabled(newEnabled); // Update state to force a re-render
    };

    const handleReset = () => {
        window.location.href = "/app";
    };

    return (
        <div>
            <h2>Public Area Test</h2>
            <input
                type="checkbox"
                checked={enabled === "true"}
                onChange={handleChange}
            />
        </div>
    );
}
